import { render } from "./ViewDetachement.vue?vue&type=template&id=383de257&ts=true"
import script from "./ViewDetachement.vue?vue&type=script&lang=ts"
export * from "./ViewDetachement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__